import { useHistory } from 'react-router-dom';

import { V2_ROUTES, v2PathWithNext } from '../v2/routes';
import { useReleaseConfig } from './releaseConfig';
import useProductSessions from './useProductSessions';

// Every new personal subscription goes through Routora's paywall. Its checkout
// is authenticated, applies the server's duplicate-purchase and trial checks,
// and honours the release switch's purchase pause. Nothing here starts a
// checkout or grants access; it only decides which Routora page comes next.

/** The paywall when signed in to Routora; otherwise sign-up, then the paywall. */
export function personalPurchasePath(routoraUser) {
  return routoraUser
    ? V2_ROUTES.paywall
    : v2PathWithNext(V2_ROUTES.auth.signUp, V2_ROUTES.paywall);
}

/**
 * The action behind a personal plan's purchase button. Returns null before
 * launch, where the previous website's checkout still applies.
 *
 * Only the Routora (V2) session counts. A Teams or extension sign-in is a
 * separate legacy account and is neither a Routora sign-in nor a subscription.
 */
export function usePersonalPurchase() {
  const history = useHistory();
  const { mode } = useReleaseConfig();
  const afterLaunch = mode !== 'prelaunch';
  const sessions = useProductSessions({ enabled: afterLaunch });

  if (!afterLaunch) return null;
  return () => history.push(personalPurchasePath(sessions.personal));
}
